/* eslint-disable import/prefer-default-export */
import { PAGE_SIZE } from 'athena/components/mentoring-program/constants';
import { useMemo } from 'react';
import {
  GetMentorshipProgramGoalItemsParams,
  getMentorshipProgramGoalItems,
} from 'redux/actions/mentoring-program-goal-items';
import { MentoringProgramGoalItem } from 'redux/schemas/models/mentoring-program-goal-items';
import { getMentoringProgramGoalItemsList } from 'redux/selectors/mentorship-program-goal-items';
import { useAppDispatch } from 'redux/store';
import { usePaginatedApi } from 'shared/hooks/use-paginated-api';

type UseMentoringProgramGoals = {
  mentorshipProgramId: number;
  enrollmentId: number;
};
export const useMentoringProgramGoals = ({
  mentorshipProgramId,
  enrollmentId,
}: UseMentoringProgramGoals) => {
  const dispatch = useAppDispatch();

  const params = useMemo(
    () => ({
      pageSize: PAGE_SIZE,
      mentorshipProgramId,
      enrollmentId,
    }),
    [enrollmentId, mentorshipProgramId],
  );

  const { result: retrievedGoalItems, reset, loadMore } = usePaginatedApi<
  MentoringProgramGoalItem,
  Omit<GetMentorshipProgramGoalItemsParams, 'page'>
  >(
    (p) => dispatch(
      getMentorshipProgramGoalItems({
        ...p,
      }),
    ).then((action) => action.payload),
    params,
    getMentoringProgramGoalItemsList(enrollmentId),
  );

  return {
    reset,
    loadMore,
    goalItems: retrievedGoalItems,
  };
};
